import * as SelfServiceCheckInProcess from './checkInProcess';
import * as SelfServiceConfiguration from './configuration';
import * as SelfServiceInitialization from './initialization';

export const SelfServiceConfigurationApi = SelfServiceConfiguration;
export const SelfServiceInitializationApi = SelfServiceInitialization;
export const SelfServiceCheckInProcessApi = SelfServiceCheckInProcess;
